const state = {
  cartItems: [],
  adminAuthenticated:
    localStorage.getItem('access') !== null ? true : false,
};

export default state;
